'use strict';

angular
  .module('systemOwnerReviewControllers')

  .controller('MainSystemOwnerReviewController', [
    '$scope',
    '$state',
    '$translate',
    'topBar',
    function ($scope, $state, $translate, topBar) {
      $translate('iam.admin.systemOwnerReview.pageTitle').then(function (translation) {
        topBar.setTitleAndIcon(translation, 'fa-eye');
      });

      if ($state.is('systemOwnerReview')) {
        $state.go('systemOwnerReview.authUser', null, { reload: true, location: 'replace' });

        return;
      }
    },
  ]);
